export default __webpack_public_path__ + "static/media/req.01496601.jpg";